import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import createCanonicalUrl from "../utils/createCanonicalUrl"
import TitleAndMetaTags from "../components/TitleAndMetaTags"
import { withStyles } from "@material-ui/core/styles"

import LandingProductHero from "../components/LandingProductHero"
import LandingFancyCard from "../components/LandingFancyCard"
import LandingNews from "../components/LandingNews"
import LandingProjects from "../components/LandingProjects"
import LandingProjectsIncubate from "../components/LandingProjectsIncubate"

// import LandingContact from "../components/LandingContact"

import allProjects from "../../content/projects/projects.yml"

const styles = {
  root: {
    width: "100%",
  },
}

const HomePage = ({ data, location, classes }) => (
  <Layout location={location}>
    <TitleAndMetaTags
      title="Home &ndash; DB System NUS"
      canonicalUrl={createCanonicalUrl("/")}
    />
    <div className={classes.root}>
      <LandingProductHero />
      <LandingNews recentNews={data.allMarkdownRemark.edges} showAll={false} />
      <LandingProjectsIncubate
        projects={allProjects}
        showAll={false}
        allProjPics={data.allFile.edges}
      />
      <LandingProjects
        projects={allProjects}
        showAll={false}
        allProjPics={data.allFile.edges}
      />
      <LandingFancyCard />
      {/* <LandingContact /> */}
    </div>
  </Layout>
)

HomePage.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(HomePage)

export const homePageQuery = graphql`
  query recentTwoNewsAndAllProjectsPicsQuery {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 4
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
            featuredImage {
              childImageSharp {
                fixed(width: 150) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
          fields {
            slug
          }
          excerpt
        }
      }
    }
    allFile(
      filter: { absolutePath: { regex: "/content/images/dbsystem-projects/" } }
    ) {
      edges {
        node {
          childImageSharp {
            fixed(height: 150) {
              originalName
              src
            }
          }
        }
      }
    }
  }
`
